import { SEO } from "@/components/seo/SEO";
const RefundPolicy = () => {
  return <>
      <SEO title="Refund & Cancellation Policy | Careerfy" description="Understand Careerfy's no-refund policy and subscription cancellation terms." path="/refund-policy" structuredData={{
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Refund & Cancellation Policy",
      url: "/refund-policy"
    }} />
      <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-title font-semantic-bold text-primary mb-8">Refund & Cancellation Policy</h1>
      
      <div className="space-y-6 text-gray-600">
        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">No Refund Policy</h2>
          <p>At Careerfy (HeyLiving Club LLP), we maintain a strict no-refund policy for all purchases made on our platform. This includes but is not limited to:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Premium subscription payments</li>
            <li>Interview preparation packages</li>
            <li>Any other services provided through our platform</li>
          </ul>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">Subscription Cancellation</h2>
          <p>While refunds are not provided, users may cancel their subscription at any time. However:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>The service will remain active until the end of the current billing period</li>
            <li>No partial refunds will be issued for unused periods</li>
            <li>Users will retain access to all features until the subscription period ends</li>
          </ul>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">Technical Issues</h2>
          <p>In case of technical issues, we are committed to resolving them promptly. Please contact our support team for assistance with any service-related problems.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">Contact Information</h2>
          <p>For any questions about this policy, please contact us:</p>
          <ul className="list-none space-y-2 mt-2">
            <li>Company: HeyLiving Club LLP</li>
            <li>Email: hello@careerfy.ai</li>
            
          </ul>
        </section>
      </div>
      </div>
    </>;
};
export default RefundPolicy;